// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__TUwjp","lock-container":"styles_lock-container__BLNmp","lockContainer":"styles_lock-container__BLNmp"};